import { FormControl, MenuItem, Select } from "@material-ui/core";
import { useState } from "react";
import NextButton from "./NextButton";
import PrevButton from "./PrevButton";
import ArrowDropDown from "../../assets/images/downArrow.svg";

const Pagination = ({
  currentPage,
  numberOfElement,
  handlePrev,
  pageSize,
  handleKeyPress,
  handlePageSize,
  setPage,
  totalPages,
  handleNext,
}) => {
  const [selectOpen, setSelectOpen] = useState(false);

  const ArrowDropDownIcon = (props) => {
    const { className, style, onClick, ...rest } = props || {};
    return (
      <span
        {...rest}
        className={className}
        onClick={(e) => {
          setSelectOpen((s) => !s);
          if (onClick) onClick(e);
        }}
        style={{
          ...(style || {}),
          display: "inline-flex",
          alignItems: "center",
          pointerEvents: "auto",
          marginLeft: 10,
        }}
      >
        <img
          src={ArrowDropDown}
          alt="ArrowDropDown"
          style={{ width: 12, height: 12, pointerEvents: "none" }}
        />
      </span>
    );
  };
  return (
    <div className="table-pagination channel-pagination">
      <div className="pagination-count">
        <div className="itemPerPage">
          <div className="countDropdown">
            <div className="itemtext">Items per page</div>
            <FormControl variant="outlined" className="custom-select-wrapper">
              <Select
                value={pageSize}
                onChange={handlePageSize}
                displayEmpty
                className="custom-select"
                IconComponent={ArrowDropDownIcon}
                open={selectOpen}
                onOpen={() => setSelectOpen(true)}
                onClose={() => setSelectOpen(false)}
                MenuProps={{
                  PaperProps: {
                    className: "page-dropdown",
                  },
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="count">
            <span>
              {`${Math.min(
                currentPage * pageSize + 1,
                numberOfElement
              )}-${Math.min((currentPage + 1) * pageSize, numberOfElement)}`}
            </span>
            of<span>{`${numberOfElement}`}</span> entries
          </div>
        </div>

        <div className="pagination-arrow">
          {/* Previous Button */}
          <button
            className={`prev ${currentPage === 0 ? "disabled" : ""}`}
            onClick={handlePrev}
            disabled={currentPage === 0}
          >
            <PrevButton />
          </button>

          <div className="pagesCounts">
            Page
            <form onSubmit={handleKeyPress}>
              <input
                type="number"
                defaultValue={currentPage + 1}
                onChange={setPage}
                name="inputpage"
                min={1}
                max={totalPages}
                className="no-arrows"
              />
            </form>
            of <span>{totalPages}</span>
          </div>

          {/* Next Button */}
          <button
            className={`next ${
              currentPage === totalPages - 1 ? "disabled" : ""
            }`}
            onClick={handleNext}
            disabled={currentPage === totalPages}
          >
            <NextButton />
          </button>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Pagination;
